export enum FindAllStationsSort {
  CREATED_DATE = 'createdDate',
  UPDATED_DATE = 'updatedDate',
}
